import Vue from 'vue';
import { BASE_URL } from '@/api/const.js';

let user = JSON.parse(localStorage.getItem('user'));

export default {
    // fetching calls list
    fetchTariffList() {
        return Vue.http.get(BASE_URL + 'userdata/tariff-list/', {
            headers: {
                Authorization: 'AlertButton ' + user.token,
            },
        });
    },
};
